"use client";
import { type FrameLayout } from "./replay-frame.types";

export function frameSize({
  height = "min(900px, 88vh)",
  minHeight = "360px",
}: FrameLayout) {
  return {
    height: height === "auto" ? undefined : height,
    minHeight,
    aspectRatio: height === "auto" ? "16 / 9" : undefined,
  };
}
